import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
  return {
    type: types.MODULE_DOKTER_SET_LOADER,
    value: data,
  };
};

export const getDataDokter = (value) => {
  return {
    type: types.MODULE_DOKTER_DATA_GET,
    value,
  };
};

export const getRiwayatPenyakitPasien = (value) => {
  return {
    type: types.MODULE_DOKTER_RIWAYAT_PENYAKIT_PASIEN,
    value,
  };
};

export const validateDokterCode = (history, value) => {
  return {
    type: types.MODULE_DOKTER_VALIDATE_CODE,
    history,
    value,
  };
};

export const initFormDokter = (value) => {
  return {
    type: types.MODULE_DOKTER_INIT_FORM_DOKTER,
    value,
  };
};

export const initCariDokter = (value) => {
  return {
    type: types.MODULE_DOKTER_INIT_FORM_CARI_DOKTER,
    value,
  };
};

export const getMasterData = () => {
  return {
    type: types.MODULE_DOKTER_MASTER_DATA,
  };
};

export const getListDokterPraktek = () => {
  return {
    type: types.MODULE_DOKTER_DATA_GET_LIST_DOKTER_PRAKTEK,
  };
};

export const handleStateForm = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_FORM,
    property,
    value,
  };
};

export const handleStateCariDokter = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_CARI_DOKTER,
    property,
    value,
  };
};

export const handleStateDokterPraktek = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_DOKTER_PRAKTEK,
    property,
    value,
  };
};

export const handleStateJadwalPraktek = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_JADWAL_PRAKTEK,
    property,
    value,
  };
};

export const handleStateJadwalPraktek2 = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_JADWAL_PRAKTEK2,
    property,
    value,
  };
};

export const handleAddJadwal = (hari, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_ADD_JADWAL,
    hari,
    value,
  };
};

export const handleStateOuter = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_OUTER,
    property,
    value,
  };
};

export const postForm = (history, value) => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_FORM,
    history,
    value,
  };
};

export const postFormDokterPraktek = (history, value) => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_FORM_DOKTER_PRAKTEK,
    history,
    value,
  };
};

export const postFormJadwalPraktek = (history, value) => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_FORM_JADWAL_PRAKTEK,
    history,
    value,
  };
};

export const getDropdownListLayanan = () => {
  return {
    type: types.MODULE_DOKTER_DROPDOWN_LAYANAN_GET,
  };
};

export const handleStateFormModalLayanan = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_LAYANAN,
    property,
    value,
  };
};

export const handleStateFormModalObat = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_OBAT,
    property,
    value,
  };
};

export const addLayananToList = () => {
  return {
    type: types.MODULE_DOKTER_HANDLE_ADD_LAYANAN_TO_LIST,
  };
};

export const submitModalLayanan = () => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_MODAL_LAYANAN,
  };
};

export const submitModalObat = () => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_MODAL_OBAT,
  };
};

export const getDetailLayananByDropdown = (property, value) => {
  return {
    type: types.MODULE_DOKTER_LISTDATA_LAYANAN_GET,
    value,
  };
};

export const getDetailObatByDropdown = (property, value) => {
  return {
    type: types.MODULE_DOKTER_LISTDATA_OBAT_GET,
    value,
  };
};

export const getDropdownObatLayanan = () => {
  return {
    type: types.MODULE_DOKTER_DROPDOWN_OBAT_GET,
  };
};

export const addObatToList = () => {
  return {
    type: types.MODULE_DOKTER_HANDLE_ADD_OBAT_TO_LIST,
  };
};

export const getDropdownICD = () => {
  return {
    type: types.MODULE_DOKTER_DROPDOWN_ICD_GET,
  };
};

export const checkStatusDiagnosa = (value) => {
  return {
    type: types.MODULE_DOKTER_CHECK_STATUS_DIAGNOSA,
    value,
  };
};

export const toDiagnosaStep1 = (value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_DIAGNOSA1,
    value,
  };
};

export const handleStateDiagnosaStep2 = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_DIAGNOSA2,
    property,
    value,
  };
};

export const handleStateDiagnosaStep3 = (property, value) => {
  return {
    type: types.MODULE_DOKTER_HANDLE_STATE_DIAGNOSA3,
    property,
    value,
  };
};

export const toDiagnosaStep2 = (value) => {
  return {
    type: types.MODULE_DOKTER_TO_DIAGNOSA2,
    value,
  };
};

export const toDiagnosaStep3 = (value) => {
  return {
    type: types.MODULE_DOKTER_TO_DIAGNOSA3,
    value,
  };
};

export const initFormDiagnosa1 = () => {
  return {
    type: types.MODULE_DOKTER_INIT_FORM_DIAGNOSA1,
  };
};

export const initFormDiagnosa2 = (value) => {
  return {
    type: types.MODULE_DOKTER_INIT_FORM_DIAGNOSA2,
    value,
  };
};

export const initFormDiagnosa3 = (value) => {
  return {
    type: types.MODULE_DOKTER_INIT_FORM_DIAGNOSA3,
    value,
  };
};
export const initFormDiagnosa4 = (value) => {
  return {
    type: types.MODULE_DOKTER_INIT_FORM_DIAGNOSA4,
    value,
  };
};

export const submitFormDiagnosa1 = (value) => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA1,
    value,
  };
};

export const submitFormDiagnosa2 = (value) => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA2,
    value,
  };
};

export const submitFormDiagnosa3 = (value) => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA3,
    value,
  };
};

export const submitFormDiagnosa4 = (history, value) => {
  return {
    type: types.MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA4,
    history,
    value,
  };
};
//
